import React from 'react';
import {css} from 'emotion';
import Vivo from '../images/vivo.png';
import Vivo2x from '../images/vivo@2x.png';
import Vivo3x from '../images/vivo@3x.png';

const SectionFAQ = () => {
    return (
        <section
            className={css`
                background-color: #fff;
                padding: 10px 40px 10px 40px;
                text-align: center;
            `}
        >
            <div
                className={css`
                    max-width: 230px;
                    margin: auto;
                    margin-top: -125px;
                    display:none;
                `}
            >
                <img
                    src={Vivo}
                    srcSet={`${Vivo} 1x, ${Vivo2x} 2x, ${Vivo3x} 3x`}
                    alt=""
                    className={css`
                        max-width: 230px;
                        width: 100%auto;
                    `}
                />
                {/* <Image fluid={imagen.sharp.fluid} /> */}
            </div>

            <h3
                className={css`
                    margin-top: 20px;
                    margin-bottom: 10px;
                `}
            >
                Preguntas frecuentes
            </h3>

            <div
                className={css`
                    text-align: justify;
                    margin-top: 40px;
                    max-width: 593px;
                    margin: auto;
                `}
            >
                <p>
                    <strong>¿Quiénes pueden participar del Acto de Colación?</strong>
                    <br />
                    Todos aquellos egresados de las carreras de 3 años del periodo comprendido entre octubre de 2022 y octubre de 2023.
                </p>

                <p>
                    <strong>¿Cómo puedo obtener mi título original y analítico legalizado por el Ministerio de Educación de la Nación?</strong>
                    <br />
                    Este tiene un plazo de entrega de 12 meses aproximadamente, desde la fecha en que rendiste el Seminario Final de Carrera. Podés consultar si está listo, enviando un email a <a href="mailto:prosecretaria@ies21.edu.ar">prosecretaria@ies21.edu.ar</a>.
                </p>

                <p>
                    <strong>¿Cuándo y dónde retiro mi diploma?</strong> <br />
                    Tu diploma, que representa la culminación de tus estudios de nivel superior, se te entregará durante el acto o podrás retirarlo a partir del día lunes 13 de noviembre en la Prosecretaría Académica de IES en Rondeau 165.
                </p>

                <p>
                    <strong>¿Es obligatorio participar del Acto de Colación?</strong>
                    <br />
                    La asistencia al Acto de Colación no es obligatoria y se puede participar de manera presencial, o virtual a través de la plataforma Zoom en caso de que lo solicites:  <a href="mailto:plovaiza@ies21.edu.ar">plovaiza@ies21.edu.ar</a> Pilar Lovaiza.
                </p>

                <p>
                    <strong>
                        ¿Mis amigos y familiares podrán sumarse al Acto de Colación?
                    </strong>
                    <br />
                   Solo podrán acompañarte a este acto de manera presencial 3 (tres) familiares o amigos que vos decidas, van a poder retirar sus entradas hasta el viernes 04 de noviembre,  en el Depto de Comunicación || Rondeau 165, CBA. Aquellos que deseen compartir este momento tan importante para vos y no puedan asistir presencialmente, podrán seguir el acto de manera virtual desde el <a href="https://www.youtube.com/user/IESVID" target="_blank" rel="noopener noreferrer">canal de YouTube de IES</a>.
                </p>

                <p>
                    <strong>¿Cómo debo vestirme para asistir al Acto de Colación?</strong>
                    <br />
                    Recomendamos elegante sport.
                </p>

                <p>
                    <strong>¿A qué hora debo llegar?</strong>
                    <br />
                    En caso de asistir presencialmente, es importante que te presentes <span className={css`
                    font-size:2rem; font-weight: 700`}> una hora antes </span> del acto ya que deberás acreditarte.
                    <br />
                    Tus familiares podrán ingresar al espacio 30 minutos antes del inicio del acto presencial.
                    <br />
                    En caso de hacerlo por Zoom, debes ingresar a la sala 20 minutos antes del comienzo del acto.
                    <br />
                    Solicitamos puntualidad                    .
                </p>
                <p>
                    <strong>Beneficios</strong>
                    <br />
                    Fotografía: Te ofreceremos un servicio de fotografías sin costo, que luego subiremos a nuestra página institucional para que puedas descargarlas a partir del lunes 20 de noviembre.
                </p>
            </div>
        </section>
    );
};

export default SectionFAQ;
